module.exports = __webpack_public_path__ + "static/media/Auckland2.3bd10d9f.mp4";